import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { I18nModule } from '@recruitee/i18n';

import { HeadingModule } from './../heading/heading.module';
import { IconModule } from './../icon/icon.module';
import { TruncateModule } from './../truncate/truncate.module';
import { StarsRatingComponent } from './stars-rating.component';

@NgModule({
  declarations: [StarsRatingComponent],
  exports: [StarsRatingComponent],
  imports: [IconModule, CommonModule, TruncateModule, HeadingModule, I18nModule],
})
export class StarsRatingModule {}
export { StarsRatingComponent } from './stars-rating.component';
